// AUTO-GENERATED by tools/gen-i18n-resources.js — do not edit.
// Source: src/locales/<lang>/<namespace>.json
import de_accountManagement from 'locales/de/accountManagement.json'
import de_admin from 'locales/de/admin.json'
import de_alertLegacy from 'locales/de/alertLegacy.json'
import de_alerts from 'locales/de/alerts.json'
import de_bi from 'locales/de/bi.json'
import de_catalog from 'locales/de/catalog.json'
import de_common from 'locales/de/common.json'
import de_competition from 'locales/de/competition.json'
import de_errors from 'locales/de/errors.json'
import de_feedback from 'locales/de/feedback.json'
import de_home from 'locales/de/home.json'
import de_layout from 'locales/de/layout.json'
import de_navigation from 'locales/de/navigation.json'
import de_packages from 'locales/de/packages.json'
import de_parity from 'locales/de/parity.json'
import de_profile from 'locales/de/profile.json'
import de_realtime from 'locales/de/realtime.json'
import de_report from 'locales/de/report.json'
import de_rooms from 'locales/de/rooms.json'
import de_session from 'locales/de/session.json'
import de_tables from 'locales/de/tables.json'
import de_tour from 'locales/de/tour.json'
import en_accountManagement from 'locales/en/accountManagement.json'
import en_admin from 'locales/en/admin.json'
import en_alertLegacy from 'locales/en/alertLegacy.json'
import en_alerts from 'locales/en/alerts.json'
import en_bi from 'locales/en/bi.json'
import en_catalog from 'locales/en/catalog.json'
import en_common from 'locales/en/common.json'
import en_competition from 'locales/en/competition.json'
import en_errors from 'locales/en/errors.json'
import en_feedback from 'locales/en/feedback.json'
import en_home from 'locales/en/home.json'
import en_layout from 'locales/en/layout.json'
import en_navigation from 'locales/en/navigation.json'
import en_packages from 'locales/en/packages.json'
import en_parity from 'locales/en/parity.json'
import en_profile from 'locales/en/profile.json'
import en_realtime from 'locales/en/realtime.json'
import en_report from 'locales/en/report.json'
import en_rooms from 'locales/en/rooms.json'
import en_session from 'locales/en/session.json'
import en_tables from 'locales/en/tables.json'
import en_tour from 'locales/en/tour.json'
import es_accountManagement from 'locales/es/accountManagement.json'
import es_admin from 'locales/es/admin.json'
import es_alertLegacy from 'locales/es/alertLegacy.json'
import es_alerts from 'locales/es/alerts.json'
import es_bi from 'locales/es/bi.json'
import es_catalog from 'locales/es/catalog.json'
import es_common from 'locales/es/common.json'
import es_competition from 'locales/es/competition.json'
import es_errors from 'locales/es/errors.json'
import es_feedback from 'locales/es/feedback.json'
import es_home from 'locales/es/home.json'
import es_layout from 'locales/es/layout.json'
import es_navigation from 'locales/es/navigation.json'
import es_packages from 'locales/es/packages.json'
import es_parity from 'locales/es/parity.json'
import es_profile from 'locales/es/profile.json'
import es_realtime from 'locales/es/realtime.json'
import es_report from 'locales/es/report.json'
import es_session from 'locales/es/session.json'
import es_tables from 'locales/es/tables.json'
import es_tour from 'locales/es/tour.json'
import pt_accountManagement from 'locales/pt/accountManagement.json'
import pt_admin from 'locales/pt/admin.json'
import pt_alertLegacy from 'locales/pt/alertLegacy.json'
import pt_alerts from 'locales/pt/alerts.json'
import pt_bi from 'locales/pt/bi.json'
import pt_catalog from 'locales/pt/catalog.json'
import pt_common from 'locales/pt/common.json'
import pt_competition from 'locales/pt/competition.json'
import pt_errors from 'locales/pt/errors.json'
import pt_feedback from 'locales/pt/feedback.json'
import pt_home from 'locales/pt/home.json'
import pt_layout from 'locales/pt/layout.json'
import pt_navigation from 'locales/pt/navigation.json'
import pt_packages from 'locales/pt/packages.json'
import pt_parity from 'locales/pt/parity.json'
import pt_profile from 'locales/pt/profile.json'
import pt_realtime from 'locales/pt/realtime.json'
import pt_report from 'locales/pt/report.json'
import pt_rooms from 'locales/pt/rooms.json'
import pt_session from 'locales/pt/session.json'
import pt_tables from 'locales/pt/tables.json'
import pt_tour from 'locales/pt/tour.json'

export const resources = {
    de: {
        accountManagement: de_accountManagement,
        admin: de_admin,
        alertLegacy: de_alertLegacy,
        alerts: de_alerts,
        bi: de_bi,
        catalog: de_catalog,
        common: de_common,
        competition: de_competition,
        errors: de_errors,
        feedback: de_feedback,
        home: de_home,
        layout: de_layout,
        navigation: de_navigation,
        packages: de_packages,
        parity: de_parity,
        profile: de_profile,
        realtime: de_realtime,
        report: de_report,
        rooms: de_rooms,
        session: de_session,
        tables: de_tables,
        tour: de_tour,
    },
    en: {
        accountManagement: en_accountManagement,
        admin: en_admin,
        alertLegacy: en_alertLegacy,
        alerts: en_alerts,
        bi: en_bi,
        catalog: en_catalog,
        common: en_common,
        competition: en_competition,
        errors: en_errors,
        feedback: en_feedback,
        home: en_home,
        layout: en_layout,
        navigation: en_navigation,
        packages: en_packages,
        parity: en_parity,
        profile: en_profile,
        realtime: en_realtime,
        report: en_report,
        rooms: en_rooms,
        session: en_session,
        tables: en_tables,
        tour: en_tour,
    },
    es: {
        accountManagement: es_accountManagement,
        admin: es_admin,
        alertLegacy: es_alertLegacy,
        alerts: es_alerts,
        bi: es_bi,
        catalog: es_catalog,
        common: es_common,
        competition: es_competition,
        errors: es_errors,
        feedback: es_feedback,
        home: es_home,
        layout: es_layout,
        navigation: es_navigation,
        packages: es_packages,
        parity: es_parity,
        profile: es_profile,
        realtime: es_realtime,
        report: es_report,
        session: es_session,
        tables: es_tables,
        tour: es_tour,
    },
    pt: {
        accountManagement: pt_accountManagement,
        admin: pt_admin,
        alertLegacy: pt_alertLegacy,
        alerts: pt_alerts,
        bi: pt_bi,
        catalog: pt_catalog,
        common: pt_common,
        competition: pt_competition,
        errors: pt_errors,
        feedback: pt_feedback,
        home: pt_home,
        layout: pt_layout,
        navigation: pt_navigation,
        packages: pt_packages,
        parity: pt_parity,
        profile: pt_profile,
        realtime: pt_realtime,
        report: pt_report,
        rooms: pt_rooms,
        session: pt_session,
        tables: pt_tables,
        tour: pt_tour,
    },
}

export const NAMESPACES = ['accountManagement', 'admin', 'alertLegacy', 'alerts', 'bi', 'catalog', 'common', 'competition', 'errors', 'feedback', 'home', 'layout', 'navigation', 'packages', 'parity', 'profile', 'realtime', 'report', 'rooms', 'session', 'tables', 'tour']
